import React from 'react';
import { FileUploadAPIType, MatchedNodeType } from '../Response/Model';
import Button from '../Buttons/Button/Button';

/**
 * @description
 * fileSubType can be set as a empty array,
 * if there is no validation required for file types
 */
type Props = {
  onChange: (file: File, isValidated: boolean) => void;
  fileSubType: string[];
  icon: string;
  label: string;
  allowedTypes: string[];
  maxFileSizeInBytes: number;
  style?: React.CSSProperties;
  disable?: boolean;
};

function FileSelect(props: Props & FileUploadAPIType & MatchedNodeType) {
  const fileElementRef = React.useRef(null);
  const fileSelectorOpener = () => {
    fileElementRef.current.click();
  };
  const allowedTypes = React.useMemo(
    () =>
      props.allowedTypes
        ? props.allowedTypes.map(e => (e[0] === '.' ? e : '.' + e)).join(',')
        : 'all',
    [props.allowedTypes]
  );
  const isValidated = (file: File) => {
    const type = file.name.split('.').pop();

    let validationSuccessCount = 0;
    if (file.size <= props.maxFileSizeInBytes) {
      validationSuccessCount += 1;
    }
    if (props.fileSubType.length === 0) {
      validationSuccessCount += 1;
    } else {
      if (props.fileSubType.indexOf(type) !== -1) {
        validationSuccessCount += 1;
      }
    }
    return validationSuccessCount === 2;
  };
  const validateOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();
    const file = e.target.files[0];

    props.onChange(file, isValidated(file));
  };

  const fileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.persist();
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    props.onChange(file, isValidated(file));
  };

  const handleOnClick = (e: React.MouseEvent<HTMLInputElement>) => {
    const element = e.target as HTMLInputElement;
    element.value = '';
  };

  return (
    <div
      className="sf-fileselect-w"
      style={props.style}
      onClick={fileSelectorOpener}
      onDrop={fileDrop}
      onDragOver={e => e.preventDefault()}
    >
      <Button
        variant="filled"
        label="Select file"
        fullWidth
        disabled={props.disable}
      >
        <input
          className="upload-input"
          style={{ display: 'none' }}
          ref={fileElementRef}
          type="file"
          onChange={validateOnChange}
          accept={allowedTypes}
          onClick={handleOnClick}
        />
      </Button>
      {/* <div style={{ opacity: 0.6, fontWeight: 'bold' }}>
        <img src={props.icon} />
        <span>{props.label}</span>
      </div> */}
    </div>
  );
}

export default FileSelect;
